import request from '@/utils/request'

// 获取提现最低金额
export function getDrawConfig() {
    return request({
        url: '/agent/config/draw',
        method: 'get',
    })
}

// 获取用户已绑定账户
export function getTransferAccount() {
    return request({
        url: '/agent/personal/get-transfer-account',
        method: 'get',
    })
}

// 获取验证码
export function getDrawSMS() {
    return request({
        url: '/agent/personal/transfer-valid',
        method: 'post',
    })
}

// 确认提现
export function confirmDraw(data) {
    return request({
        url: '/agent/personal/create-transfer-record',
        method: 'post',
        data
    })
}

// 获取微信配置
export function getVxConfigs(url) {
    return request({
        url: '/agent/personal/check-transfer-authorization?url='+url,
        method: 'get',
    })
}

// 获取微信网页授权链接
export function getCodeByAuthUrl() {
    return request({
        url: '/agent/personal/getCodeByAuthUrl',
        method: 'get',
    })
}

// 获取用户的微信信息
export function getWeChatInfoByWeb(code) {
    return request({
        url: `agent/personal/getWeChatInfoByWeb/${code}`,
        method: 'get',
    })
}
// 获取提现列表
export function getWithdrawList(params) {
    return request({
        url: '/agent/personal/get-transfer-record',
        method: 'get',
        params,
    })
}


// WEBPACK FOOTER //
// ./src/api/withdraw.js